import {
  initialState,
  Actions,
  State,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_ERROR,
  RESET_EDIT_CUSTOMER,
} from '../../types/customer/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CUSTOMER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_CUSTOMER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_CUSTOMER:
      return initialState
    default:
      return state
  }
}

export default reducers
